import { DateTimeDataFormat } from 'Lib/Format';
import React from 'react';
import { DateInput, DateTimeInput, Field, NumericInput, RadioGroup, TextOutput } from '../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent } from '../../../Core/types';

let HydrometerPortionAgitationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <NamePrefixModifier appendNamePrefix="Agitation">
        <ListFieldSection heading="Initial Agitation">
          <Field
            input={<RadioGroup />}
            name="DispersingAgent"
            options={['Hexa-sodium hexametaphosphate', 'Tetra-sodium diphosphate'].map((x) => ({ label: x, value: x }))}
            freeEntry={true}
            freeEntryLabel="Other"
            freeEntryMaxLength={100}
          />
          <Field input={<DateInput />} dataFormat={DateTimeDataFormat.Date} name="DateDispersingAgentPrepared" />
          <Field input={<NumericInput />} name="DispersingAgentVolume" />
          <Field
            input={<DateTimeInput />}
            dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
            name="DateTimeAgitationStartedLocal"
          />
          <Field
            input={<DateTimeInput />}
            dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
            name="DateTimeAgitationFinishedLocal"
          />
          <Field input={<TextOutput />} name="Duration" />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};
HydrometerPortionAgitationSection = withInjectedProps(HydrometerPortionAgitationSection);

export { HydrometerPortionAgitationSection };
export default HydrometerPortionAgitationSection;
